import { createSessionsColumnDefinitions } from "../SessionsTableColumns";

const sessionsColumnDefinitions = createSessionsColumnDefinitions();

export const SESSIONS_FIXED_COLUMNS = Object.keys(sessionsColumnDefinitions)
  .slice(0, 2);

export const DEFAULT_SESSIONS_VISIBLE_COLUMNS = Object.keys(
  sessionsColumnDefinitions
).filter((key) => !SESSIONS_FIXED_COLUMNS.includes(key));

export const sessionsColumnOptions = Object.values(sessionsColumnDefinitions)
  .filter(({ key }) => !SESSIONS_FIXED_COLUMNS.includes(key))
  .map(({ key, label }) => ({ text: label, value: key }));
